export const settlementFilterState = () => ({
  searchKey: "",
  perPage: 10,
  page: 1
})